import React, {Component,} from 'react';
import  {findDOMNode,} from 'react-dom';

import {reverseParseTextView} from './createRender';
import {TYPE_MAP,TYPE_MAP_VIEW,WELL_CHOSEN_MAP} from '../../../utils/questionType';
import {Rate,Tooltip} from 'antd'
import {ONLINESTATUS} from '../../../utils/questionManageType';
import Footer from '../exercise/Footer';

const $ = require('$');
const MathQuill = require('MathQuill');

const MQ = MathQuill.getInterface(2);

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }
    toggleAnswer = (val, e, id, rightAnswer) => {
        // val && cnzz.statistics('PC端作业详情页', 2, '展开答案'); /** 打点统计 */
        e.stopPropagation();
        this.setState({visible: val});

    };
    componentDidMount() {
        this.MQLoad();
        if(this.props.data.subject==='0'){
            this.setState({visible:true})  //数学题默认答案显示
        }
        let data = reverseParseTextView(this.props.data);
        this.props.getData && this.props.getData(data);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.data.question_id !== this.props.data.question_id) {
            let data = reverseParseTextView(this.props.data);
            this.props.getData && this.props.getData(data);
        }
        this.MQLoad();
    }
    MQLoad = () => {
        const {data} = this.props;
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            })
        $('audio', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('audio', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('audio', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
    };
    drawLine = (id, rightAnswer, val) => {
        let c = document.getElementById(`canvas-${id}`);
        if(!c){return}
        let ctx = c.getContext("2d");
        if (val) {
            let lh = $(c).prev().outerHeight();
            let rh = $(c).next().outerHeight();
            if (lh > rh) {
                c.height = lh * 2;
                c.style.height = lh + 'px';
            } else {
                c.height = rh * 2;
                c.style.height = rh + 'px';
            }
            ctx.beginPath();
            ctx.lineCap = "round";
            ctx.lineWidth = 5;
            ctx.strokeStyle = '#00afff';
            let lele = '', rele = '';
            for (let key in rightAnswer) {
                lele = $(c).prev().find('.line-item');
                rele = $(c).next().find('.line-item');
                rightAnswer[key].forEach(item => {
                    ctx.moveTo(10, lele.eq(parseInt(key) - 1).outerHeight() + lele.eq(parseInt(key) - 1).position().top * 2);
                    ctx.lineTo(245 * 2, rele.find(`p[data-id=${item}]`).parent().outerHeight() + rele.find(`p[data-id=${item}]`).parent().position().top * 2);
                });
            }
            ctx.stroke();
        } else {
            c.height = c.height;
        }
    };

    mapTag = str => {
        let stem  = str;
        let regStem = /\(!([āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑńňɡａ-ｚＡ－ＺA-Za-z\\s∥-]+)!\)/ig;
        let regAllText = /([\u4e00-\u9fa5]\(![āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑńňɡａ-ｚＡ－ＺA-Za-z\\s∥-]+!\))/ig;
        stem = stem.replace(regAllText, `<ruby>$1</ruby>`);
        stem = stem.replace(regStem, `<rp>(</rp><rt>$1</rt><rp>)</rp>`);
        return stem;
    }

    createHtml = str => ({__html: str ? str : `&nbsp;`});


    render() {
        const {visible} = this.state;
        let originData = this.props.data;
        if(this.props.errorAnswer){originData.answer = this.props.errorAnswer}//题目检错页显示的是错的的答题答案

        let num = this.props.num;
        let index = this.props.index;

        let data = reverseParseTextView(originData);
        let stem = data.stem || '';
        if (stem) {
            stem = this.mapTag(stem);
        }
        if(!data){
            return (
                <div className="box-exercise ligature" ref={'viewer'}>
                    <div className="exercise-content">
                        <div><h3 style={{color:'red',textAlign:'center'}}>此题解析有误</h3></div>
                        {num!=='undefined'&&<div className="exercise-num"><p className="math_text" style={{margin: 0,lineHeight: '27px'}}>{index || index === 0 ? `${index+1} - ${num+1}`  : `${num+1}、`}</p></div>}
                        <div className="exercise-con">
                            <div  style={{border:'1px solid red'}} >
                                {originData.stem}
                            </div>
                        </div>
                    </div>
                    <div className="exercise-footer">
                        {
                            visible &&
                            <div className="footer-hide relative">
                                <div>
                                    {originData.answer}
                                </div>
                                {
                                    data.explain && <div>
                                        <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                        <div className="inline-block">
                                            <span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(originData.explain)}/>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        <div className="footer-show relative">
                            <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                                {
                                    this.props.canShowAnswer ?
                                        <button
                                            className="question-btn"
                                            onClick={(e) => this.toggleAnswer(!visible,e)}>
                                            {!visible ? '显示答案' : '隐藏答案'}
                                        </button> : null
                                }

                            </Footer>
                        </div>
                    </div>
                </div>
                )

        }
        const imgs = $(findDOMNode(this)).find('img');
        this.drawLine(originData.id, data.answer, this.state.visible);
        if (imgs.length === 0) {
            setTimeout(()=>{this.drawLine(originData.id, data.answer, this.state.visible);},1000)
        } else {
            imgs.load(() => {
                this.drawLine(originData.id, data.answer, this.state.visible);
            });
        }

        return (
            <div className="box-exercise ligature" ref={'viewer'}>
                <div className="exercise-content">
                    {num!=='undefined'&&<div className="exercise-num"><p className="math_text" style={{margin: 0,lineHeight: '27px'}}>{index || index === 0 ? `${index+1} - ${num+1}`  : `${num+1}、`}</p></div>}
                    <div className="exercise-con">
                        <div dangerouslySetInnerHTML={this.createHtml(stem)}/>
                        <div style={{width: '100%'}} className={'questionCore'}>
                            {
                                data.leftList && !!data.leftList.length &&
                                <div style={{width: '40%'}} className="inline-block relative">
                                    {
                                        data.leftList.map((val, key) =>
                                            <div key={key} className="line-item"
                                                 dangerouslySetInnerHTML={this.createHtml(this.mapTag(val))}/>
                                        )
                                    }
                                </div>
                            }
                            {
                                data.leftList && !!data.leftList.length &&
                                data.rightList && !!data.rightList.length &&
                                <canvas id={`canvas-${originData.id}`} width={500} height={400}
                                        style={{width: '20%', height: 200}}/>
                            }
                            {
                                data.rightList && !!data.rightList.length &&
                                <div style={{width: '40%'}} className="inline-block relative">
                                    {
                                        data.rightList.map((val, key) =>
                                            <div key={key} className="line-item"
                                                 dangerouslySetInnerHTML={this.createHtml(this.mapTag(val))}/>
                                        )
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="exercise-footer">
                    {
                        visible &&
                        <div className="footer-hide relative">
                            <div style={{fontSize: 14}}>{this.props.errorAnswer?'错误答案：':'正确答案：'}见蓝色连线</div>
                            {
                                data.explain && <div>
                                    <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                    <div className="inline-block">
                                        <span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(data.explain)}/>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                            {
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={(e) => this.toggleAnswer(!visible,e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }

                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/ligature/viewForView.js